(function(){
    'use strict';
    angular.module('app').controller('CreateServiceTicketModalController', CreateServiceTicketModalController);
    
    CreateServiceTicketModalController.$inject = [
        'ClientService',
        'ServiceRequestTicketService',
        'Shipments',
        '$uibModalInstance',
        'toastr'
    ];
    
    function CreateServiceTicketModalController(
        ClientService,
        ServiceRequestTicketService,
        Shipments,
        $uibModalInstance,
        toastr
    ) {
        const vm = this; 
        vm.close = close;
        vm.create = create;
        vm.getClientCompany = fetchClients;
        vm.getShipments = fetchShipments;

        vm.clients = [];
        vm.shipments = [];
        vm.ticket = {};

        vm.categoryList = [
            {value:'CANCELLATION_REQUEST', name: 'Cancellation request'},
            {value:'DAMAGED_ON_DELIVERY', name: 'Damaged on delivery'},
            {value:'DELIVERED_TO_INCORRECT_ADDRESS', name: 'Delivered to incorrect address'},
            {value:'DELIVERY_INSTRUCTIONS', name: 'Delivery instructions'},
            {value:'DEPOT_COLLECTION_REQUEST', name: 'Depot Collection request'},
            {value:'ETA', name: 'ETA'},
            {value:'MISSED_PICKUP', name: 'Missed pickup'},
            {value:'NO_SCANNING', name: 'No Scanning/Tracking event'},
            {value:'OTHERS', name: 'Others'},
            {value:'PICKUP_INSTRUCTIONS', name: 'Pickup Instructions'},
            {value:'PROOF_OF_DELIVERY_REQUEST', name: 'Proof of delivery Request'},
            {value:'REDIRECTION', name: 'Redirection (RTS)'},
            {value:'SHORT_DELIVERY', name: 'Short Delivery'}
        ]

        init();

        function init() {
            fetchClients();
            fetchShipments();
        }

        function fetchClients(search){
            ClientService.Company.getAll(
                res=>{
                    vm.clients = res.content
                },
                err=>{
                    console.log(err)
                },{name:search,size: 10}
            )
        }

        function fetchShipments(search=null){
            Shipments.getList(res=>{
                 vm.shipments = res.content
            },err=>{
                toastr.console.error(err.message);
            },{consignmentId:search ,size: 10})
        }

        function create(form) {
            if(form.$invalid){
                form.$error.required.forEach(err => {
                    err.$setTouched()
                });
                return
            }
            const payload = fetchCleanPayload();
            ServiceRequestTicketService.create(
                res=>{
                    toastr.success('Successfully Create');
                    $uibModalInstance.close(true);
                },
                err=>{
                    console.log(err)
                    toastr.error(err.message);
                },payload
            )
        }



        function fetchCleanPayload(){
            return{
                customerId:vm.ticket.customer.reseller.id,
                contactName:vm.ticket.contactName,
                contactPhone:vm.ticket.phone,
                contactEmail:vm.ticket.email,
                shipmentId:vm.ticket.consigment.id,
                category:vm.ticket.category.value,
                issueNotes:vm.ticket.issueNotes
            }
        }

        function close() {
            $uibModalInstance.dismiss();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/service-tickets/modal/CreateServiceTicketModalController.js